var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{attrs:{"indeterminate":"","color":"primary","size":50}}),(_vm.text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }